import { Flow, Text } from 'bold-ui'
import { Fragment } from 'react'

import { HistoricoMChatTwoColumnTableItem } from './HistoricoMchatTwoColumnTableItem'

interface HistoricoMChatHeaderTableItemProps {
  numeroPergunta: string
  title: string
  value: boolean | null | undefined
  pergunta: string | undefined
  perguntaSecundaria?: string
}

export const HistoricoMChatHeaderTableItem = (props: Readonly<HistoricoMChatHeaderTableItemProps>) => {
  const { numeroPergunta, title, value, pergunta, perguntaSecundaria } = props
  const hasValue = value !== undefined && value !== null
  const hasPergunta = pergunta !== undefined

  return (
    <Flow direction='vertical' gap={0} justifyItems='stretch' style={{ width: '100%' }}>
      <Text heading={4} fontWeight='bold'>
        {'Pergunta ' + numeroPergunta}
      </Text>
      <Text heading={4} fontWeight='bold'>
        {'"' + title + '"'}
      </Text>
      {hasValue && <Text heading={4}>{value ? 'Sim' : 'Não'}</Text>}
      {hasPergunta && (
        <Fragment>
          <Text heading={4}>&nbsp;</Text>
          <HistoricoMChatTwoColumnTableItem
            left={
              <Text heading={4} fontWeight='bold'>
                {pergunta}
              </Text>
            }
            right={
              perguntaSecundaria ? (
                <Text heading={4} fontWeight='bold'>
                  {perguntaSecundaria}
                </Text>
              ) : null
            }
          />
        </Fragment>
      )}
    </Flow>
  )
}
